/* @flow */
import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';

import Column from 'components/UIKit/Flex/Column';
import Row from 'components/UIKit/Flex/Row';

import Header from './Header';

let baseStyle = {
  fontSize: '1rem',
  padding: '0.5rem 1rem',
  width: '100%'
};

export default class Section extends Component {
  static propTypes = {
    id: PropTypes.string,
    header: PropTypes.node,
    icon: PropTypes.node,
    count: PropTypes.number,
    children: PropTypes.node,
    style: PropTypes.object
  };

  sectionRef = createRef();

  render(): React.Element {
    let { id, header, children, icon, style, customDataTestID } = this.props;

    return (
      <Column data-testid={customDataTestID} id={id} style={{...baseStyle, ...style}} ref={this.sectionRef}>
        <Row>
          {Header({children: header, style: { color: '#666' }})}
          {icon && <div style={{ marginLeft: '0.6rem' }}>{icon}</div>}
        </Row>
        {children}
      </Column>
    );
  }
}
